import { BookCreationState } from './types';

export const initialState: BookCreationState = {
  currentStep: 'book-info',
  showSuccessModal: false,
  isStep1Complete: false,
  isStep2Complete: false,
  isStep3Complete: false,
  isStepPreviewComplete: false,
  isStep4Complete: false,
  bookData: {
    language: '',
    title: '',
    subtitle: '',
    author: '',
    contributors: [],
    hasISBN: false,
    isbn: '',
    bookSize: '',
    bindingType: '',
    interiorColor: '',
    paperType: '',
    coverLamination: '',
    uploadedFile: null,
    content: null,
    coverImage: null,
    coverImageSource: null,
    coverDesignerState: null,
    addons: {
      spellcheck: false,
      coverDesign: false,
      coverDesignType: null,
    }
  },
  bookId: null,
  bookStatus: null,
  reviewNotes: null,
  isSaving: false,
  isLoading: false,
  error: null
};
